import React, { useState, useEffect } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import "./PurchasePlan.css";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { ActionFormatterComponent } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import { findUploadName } from "../../../components/CommonMethod/CommonMethods";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { toast } from "react-toastify";

function PurchasePlan() {

  const baseURL = process.env.REACT_APP_Baseurl
  const userAccessToken = getItemToken('access_token');
  const labelSource = 'in-app-purchase'

  const deleteApi = `${baseURL}/admin/inapp-purchase/multi-delete`
  const getApi = `${baseURL}/admin/inapp-purchase/index`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`

  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [withOutRefresh, setWithoutRefresh] = useState(false)
  const [labelDisplay, setLabelDisplay] = useState([]);

  const userFormatter = (data, row) => {
    return (
      <div className="d-flex flex-column align-items-start">
        <span>{data}</span>
        <span className="dateText table-subheading theme-text-color">{row?.upload_on}</span>
      </div>
    );
  };


  const columns = [
    {
      dataField: "plan_price",
      text: "Plan Price",
      formatter: (cell, row) => userFormatter(cell, row),
      headerClasses: 'video-width-table'
    },
    {
      dataField: "product_id",
      text: "Product Id",
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => <ActionFormatterComponent cell={cell} row={row} link={"/edit-inapp-purchase/"} action={singleDelete} />,
    },
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: 'All', value: Number(filteredData?.length)
    }]
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        if (isSelect) {
          setItemToDelete([...itemToDelete, row.id]);
        } else {
          setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
        }
      }
    },
    style: { width: '30px' },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const allIds = rows.map((r) => r.id);
        setItemToDelete(allIds);
      } else {
        setItemToDelete([]);
      }
    },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${getApi}`, { headers: userAccessToken });
      const result = response?.data?.All_Inapp_Purchase;
      const updatedList = result?.map((item) => {
        const UploadStatus = findUploadName(item?.uploaded_by);
        return { ...item, uploaded_by: UploadStatus };
      });
      setApiData(updatedList);
      setFilteredData(updatedList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${deleteApi}`, {
        headers: userAccessToken,
        data: { id: [...itemToDelete] },
      });

      const result = response?.data;
      if (result?.status) {
        setWithoutRefresh(!withOutRefresh);
        toast.success(result?.message);
        setShowOverlay(false);
        setItemToDelete([])
      }
      else {
        toast.error(result?.message);
        setShowOverlay(false);
      }
    } catch (err) {
      var errorMessage = err?.response?.data?.message;
      toast.error(errorMessage);
      setShowOverlay(false);
    }
  };

  const labelFetch = async () => {
    try {
      const response = await axios.get(`${labelApi}`, { headers: userAccessToken });
      const result = response?.data?.label_management
      setLabelDisplay(result)
    }
    catch (err) {
      toast.error(err.response.data.message)

    }
  }

  const closeModal = () => {
    setModelClose(!closeModal);
    setShowModal(false);
    setItemToDelete([]);
    setSelectAll(false);
  };

  const reloadAction = () => {
    setShowOverlay(true);
    setTimeout(() => {
      setShowOverlay(false);
    }, 1000);
    setWithoutRefresh(prev => !prev);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDelete(selectAll ? [] : filteredData?.map((item) => item?.id));
  };

  const handleFilterChange = (data) => {
    setFilteredData(data);
  };

  useEffect(async () => {
    await fetchData();
    await labelFetch()
  }, [withOutRefresh]);

  return (
    <>
      {modelClose && <AdminDeleteModal modelClose={modelClose} deleteClose={closeModal} deleteAction={handleDeletedata} buttonText={itemToDelete?.length} />}
      {showOverlay && (<Response_Processing />)}
      <AdminNavbar heading={labelDisplay?.[5]?.title} totalDataLength={apiData?.length} deleteCount={itemToDelete?.length} navigation={"/add-inapp-purchase"} deleteMethod={openModal} navText={labelDisplay?.[6]?.title} />
      <div className="theme-bg-color p-3 rounded-2 bootstrapTable  multi-delete-width" >
        <AdminHeader hideExport searchMethod={handleFilterChange} reduceData={filteredData} originalData={apiData} fileName={"devices"} reload={true} reloadAction={reloadAction} loading={loading} customAppPlan />
        <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover headerClasses="videoWidth" selectRow={selectRow} selectAll={selectAll} loader={loading} />
      </div>
    </>
  );
}

export default PurchasePlan;